import { render, staticRenderFns } from "./RegisteredIcon.vue?vue&type=template&id=af4ebef6&scoped=true&"
import script from "./RegisteredIcon.vue?vue&type=script&lang=js&"
export * from "./RegisteredIcon.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredIcon.vue?vue&type=style&index=0&id=af4ebef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ebef6",
  null
  
)

export default component.exports